<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/groups">{{ $t('exchange_rate') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('exchange_rate_create') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="saveExchangeRate">
                <i class="fa fa-floppy-o"></i> {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-header">
                    <div class="card-item">{{ $t('exchange_rate_create') }}</div>
                </div>
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.date.required">- {{ $t('select_date') }}</div>
                        <div class="error" v-if="!$v.model.value.required">- {{ $t('enter_value') }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                <label class="label-control blue">{{ $t('date') }}</label>
                                <input type="date" class="form-control" v-model="$v.date.$model" />
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('to_date') }}</label>
                                <input type="date" class="form-control" v-model="toDate" />
                            </div>
                            <div class="form-group" :class="{ 'form-group-error': $v.model.value.$error }">
                                <label class="label-control blue">
                                    {{ $t('currency_value') }} <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" v-model="$v.model.value.$model" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
    data() {
        return {
            model: {
                date: "",
                currencyCode: "Riel",
                value: ""
            },
            date: this.$now().format('YYYY-MM-DD'),
            toDate: this.$now().format('YYYY-MM-DD')
        };
    },
    created() {
        const id = this.$route.params.id;
        if (id) {
            this.fetchExchangeRate(id);
        }
    },
    validations: {
        model: {
            value: { required }
        },
        date: { required }
    },
    methods: {
        fetchExchangeRate(id) {
            this.$api()
                .post('exchangerate/find', { Id: id })
                .then((res) => {
                    if (this.$isValid(res)) {
                        this.model = res.data.Json.ExchangeRate;
                        this.date = this.$format(this.model.date).format('YYYY-MM-DD');
                        this.toDate = this.$format(this.model.date).format('YYYY-MM-DD');
                    }
                });
        },
        saveExchangeRate() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                const loading = this.$loading.show();
                this.model.date = this.date;

                const requests = [];
                let currentDate = moment(this.date);
                const endDate = moment(this.toDate);

                while (currentDate <= endDate) {
                    requests.push({
                        date: currentDate.format('YYYY-MM-DD'),
                        currencyCode: "Riel",
                        value: this.model.value
                    });
                    currentDate = currentDate.add(1, 'days');
                }

                this.$api()
                    .post('exchangerate/save', requests)
                    .then((res) => {
                        if (this.$isValid(res)) {
                            this.$router.push('/exchangerates');
                        }
                    })
                    .finally(() => loading.hide());
            }
        }
    }
};
</script>